import config from './config'

export const ROUTE_PATH_API_COMPANY = '/company'
export const ROUTE_PATH_API_COMPANY_CONTACT_DETAILS = '/company/contact-details'
export const ROUTE_PATH_API_COMPANY_ADDRESSES = '/company/addresses'
export const ROUTE_PATH_API_COMPANY_SELF_SERVICE_STATUS = '/company/self-service-status'
export const ROUTE_PATH_API_CARDS = '/cards'
export const ROUTE_PATH_API_CARD_DETAILS = '/card/:cardId'
export const ROUTE_PATH_API_ORDER_REPLACEMENT_CARDS = '/card/order-replacement-cards'
export const ROUTE_PATH_API_ORDER_TERMINATE_CARDS = '/card/order-terminate-cards'
export const ROUTE_PATH_API_CARD_TLS_PRODUCTS = '/card/:cardId/tls-product/:page/:pageSize'
export const ROUTE_PATH_API_CARD_ROR_PRODUCTS = '/card/:cardId/ror-product/:page/:pageSize'
export const ROUTE_PATH_API_CARD_TRIPS = '/card/:cardId/trip/:page/:pageSize'
export const ROUTE_PATH_API_CARD_TRIPS_DOWNLOAD_EXPORT = '/card/:cardId/trip/export'
export const ROUTE_PATH_API_CARD_TRIP_FILTER_MONTHS = '/card/:cardId/trip/months/'
export const ROUTE_PATH_API_INVOICES = '/invoices'
export const ROUTE_PATH_API_INVOICE_DOCUMENT_DOWNLOAD = '/invoice/:invoiceNumber/documents/:documentIdentifier'
export const ROUTE_PATH_API_ORDERS = '/b2b-orders'
export const ROUTE_PATH_API_ORDER_ITEMS = '/b2b-order-items/:b2bOrderId'

export const ROUTE_PATH_API_LOGIN = '/login'
export const ROUTE_PATH_API_FORGOT_PASSWORD = '/forgot_password'
export const ROUTE_PATH_API_VERIFY_TOKEN = '/verify_token'
export const ROUTE_PATH_API_RESET_PASSWORD = '/reset_password'

// add new authenticated proxied routes here (parameter array must be ordered same as path)
export const authenticatedProxyRouteMap = [
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_COMPANY
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/customer/',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'patch',
    local: {
      path: ROUTE_PATH_API_COMPANY_CONTACT_DETAILS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/customer/contact-details',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'patch',
    local: {
      path: ROUTE_PATH_API_COMPANY_ADDRESSES
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/customer/addresses',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_COMPANY_SELF_SERVICE_STATUS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/customer/self-service-status',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARDS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_DETAILS,
      params: [{ name: 'cardId' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_TLS_PRODUCTS,
      params: [{name: 'cardId'}, {name: 'page'}, {name: 'pageSize'}]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId/tls-product/:page/:pageSize',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_ROR_PRODUCTS,
      params: [{ name: 'cardId' }, { name: 'page' }, { name: 'pageSize' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId/ror-product/:page/:pageSize',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_TRIP_FILTER_MONTHS,
      params: [{ name: 'cardId' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId/trip/months/',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_TRIPS,
      params: [{ name: 'cardId' }, { name: 'page' }, { name: 'pageSize' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId/trip/:page/:pageSize',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_CARD_TRIPS_DOWNLOAD_EXPORT,
      params: [{ name: 'cardId' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/:cardId/trip/export',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS,
      logResponseBody: false
    }
  },
  {
    method: 'post',
    local: {
      path: ROUTE_PATH_API_ORDER_REPLACEMENT_CARDS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/order-replacement-cards',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'post',
    local: {
      path: ROUTE_PATH_API_ORDER_TERMINATE_CARDS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/card/order-terminate-cards',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_INVOICES
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/invoice/',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_INVOICE_DOCUMENT_DOWNLOAD,
      params: [{ name: 'invoiceNumber' }, { name: 'documentIdentifier' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/invoice/:invoiceNumber/documents/:documentIdentifier',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS,
      logResponseBody: false
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_ORDERS
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/b2b-order/',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'get',
    local: {
      path: ROUTE_PATH_API_ORDER_ITEMS,
      params: [{ name: 'b2bOrderId' }]
    },
    proxy: {
      host: config.ASSIST_SERVICE_HOST,
      path: '/b2b-api/v1/:identifier/b2b-order-item/by-b2b-order-id/:b2bOrderId',
      useHttps: config.ASSIST_SERVICE_USE_HTTPS
    }
  }
]

export const unAuthenticatedProxyRouteMap = [
  {
    method: 'post',
    local: {
      path: ROUTE_PATH_API_LOGIN
    },
    proxy: {
      host: config.AUTHENTICATION_SERVICE_HOST,
      path: '/api/b2b/login_check',
      useHttps: config.AUTHENTICATION_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'post',
    local: {
      path: ROUTE_PATH_API_FORGOT_PASSWORD
    },
    proxy: {
      host: config.AUTHENTICATION_SERVICE_HOST,
      path: '/api/b2b/login_forgot_password',
      useHttps: config.AUTHENTICATION_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'head',
    local: {
      path: `${ROUTE_PATH_API_VERIFY_TOKEN}/:token`,
      params: [{name: 'token'}]
    },
    proxy: {
      host: config.AUTHENTICATION_SERVICE_HOST,
      path: '/api/b2b/verify_token/:token',
      params: [{name: 'token'}],
      useHttps: config.AUTHENTICATION_SERVICE_USE_HTTPS
    }
  },
  {
    method: 'patch',
    local: {
      path: `${ROUTE_PATH_API_RESET_PASSWORD}/:token`,
      params: [{name: 'token'}]
    },
    proxy: {
      host: config.AUTHENTICATION_SERVICE_HOST,
      path: '/api/b2b/reset_password/:token',
      params: [{name: 'token'}],
      useHttps: config.AUTHENTICATION_SERVICE_USE_HTTPS
    }
  }
]



// WEBPACK FOOTER //
// ./src-server/api-routes.js